import { MapTo } from '@adobe/aem-react-editable-components';
import spreadModelProps from 'helpers/spreadModelProps';
import Drawer from './Drawer';

const DrawerEditableConfig = {
  emptyLabel: 'Drawer Component',
  isEmpty: (props) => !props || !props.title,
};
export default MapTo('aweb/components/content/drawer')(spreadModelProps(Drawer), DrawerEditableConfig);
